import { baseUrl } from "../shared/api";

export function activeLoanOffers(userId) {
  return `${baseUrl()}/api/v2/users/${userId}/loan_offers/active_rcl_loan_offers`;
}

export function userLoanPlan(userId, loanPlanId) {
  return `${baseUrl()}/api/v2/users/${userId}/loan_plans/${loanPlanId}`;
}

export function upcomingPayments(leadId, params) {
  const url = new URL(`${process.env.REACT_APP_LMS_DOMAIN_API}/customers/${leadId}/upcoming_payments`);
  let searchParams = ''
  let numberOfParams = Object.keys(params).length
  Object.keys(params).forEach((key, index) => {
    const value = params[key]
    searchParams += `${key}=${value}`
    if(index < (numberOfParams - 1)) {
      searchParams += '&'
    }
  })
  return url.toString() + '?' + searchParams
}



// WEBPACK FOOTER //
// ./src/features/loans/apiUrls.js